<script lang="ts">
  export let cane: any;
  export let labels: string[][];
  export let showQty: boolean;

  import OneCane from "../common/OneCane.svelte";

  function getShort(property: string): string {
    for (const label of labels) {
      if (label[0] === property) {
        return label[1];
      }
    }
  }

</script>

{#if cane}
  <td>
    <OneCane caneData={cane.caneData} size={70} resFactor={5} />
    <div class="properties center">
      {#if showQty}<span class='quantity property'>{cane.qty}</span>{/if}<span class='complexity property'>{cane.complexity}</span>{#each cane.props as property}
        <span class={property.replace(/\s+/g, '_') + ' property'}>
          {getShort(property)}
        </span>
      {/each}
    </div>
  </td>
{/if}

<style>
  .center {
    text-align: center;
  }
</style>
